import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InsuranceDTO } from '../../../api/useInsuranceQuery';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Radio } from '../../../../../CommonComponents/OPL/Radio/Radio';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';

interface Props {
  data: InsuranceDTO;
}

export const CoverageType = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="InsuranceCoverageType"
      render={({ field: { value, onChange, disabled } }) => {
        return (
          <Box as="fieldset" border="none" p="0">
            <Text
              as="legend"
              variant="formLabel"
              color="neutral.600"
              css="display: block"
              mb="4"
              p="0"
            >
              Coverage Type
            </Text>

            <Box display="flex">
              {data.Options.InsuranceCoverageTypeOptions.map(({ value: v, label }) => (
                <Radio
                  key={label}
                  name="InsuranceCoverageType"
                  checked={value === v}
                  onChange={() => onChange(v)}
                  disabled={disabled}
                  mr="8"
                >
                  {label}
                </Radio>
              ))}
            </Box>
          </Box>
        );
      }}
    />
  );
};
